// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__2PBk0","actionsCol":"EnrolledClinics_actionsCol__3QxTu"};